import React from 'react';
import { VoucherFormSection } from '../Section';

import { VoucherFormValidityInterval } from './ValidityInterval';
import { VoucherFormUsageType } from './UsageType';
import { VoucherFormAllowedPlatforms } from './AllowedPlatforms';

interface VoucherFormBookingProps {
  template?: {
    usageType: string;
    disableAllowedPlatforms: boolean;
    disableValidity: boolean;
  };
}

const VoucherFormBooking: React.FC<VoucherFormBookingProps> = ({ template }) => {
  return (
    <VoucherFormSection
      title='Booking'
      subtitle='Where, how and when the voucher can be used'
      inputs={
        <>
          <VoucherFormUsageType usageType={template?.usageType || ''} />
          <VoucherFormAllowedPlatforms disabled={template?.disableAllowedPlatforms || false} />
          <VoucherFormValidityInterval disabled={template?.disableValidity || false} />
        </>
      }
    />
  );
};

export default VoucherFormBooking;
